/*global module, document, Image, require */
const jQuery = require('jquery');
module.exports = function getDataURIAndDimensions(src, corsProxyUrl) {
	'use strict';
	const isDataUri = function (string) {
			return (/^data:image/).test(string);
		},
		convertSrcToDataUri = function (img) {
			let ctx = false;
			if (isDataUri(img.src)) {
				return img.src;
			}
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0);
			return canvas.toDataURL('image/png');
		},
		deferred = jQuery.Deferred(),
		domImg = new Image();

	domImg.onload = function () {
		try {
			deferred.resolve({dataUri: convertSrcToDataUri(domImg), width: domImg.width, height: domImg.height});
		} catch (e) {
			deferred.reject();
		}
	};
	domImg.onerror = function () {
		deferred.reject();
	};
	if (!isDataUri(src)) {
		if (corsProxyUrl) {
			domImg.crossOrigin = 'Anonymous';
			src = corsProxyUrl + encodeURIComponent(src);
		} else {
			deferred.reject('no-cors');
		}
	}
	domImg.src = src;
	return deferred.promise();
};



//////////////////
// WEBPACK FOOTER
// ./~/mindmup-mapjs/src/get-data-uri-and-dimensions.js
// module id = 139
// module chunks = 0